import { AxiosResponse } from "axios";
import API from "../api";

import { Instruction } from "../models/instruction";

const ROUTE_NAME = "instruction";

const InstructionService = {
  async count(options?: any): Promise<AxiosResponse<number>> {
    return await API.get(`/${ROUTE_NAME}/sales/count`, { params: options });
  },
  async getById(id: number, options?: any): Promise<AxiosResponse<Instruction>> {
    return await API.get(`/${ROUTE_NAME}/sales/${id}`, { params: options });
  },
  async getAll(options?: any): Promise<AxiosResponse<Instruction[]>> {
    return await API.get(`/${ROUTE_NAME}/sales`, { params: options });
  },
  async create(instruction: Instruction): Promise<AxiosResponse<Instruction>> {
    return await API.post(`/${ROUTE_NAME}/sales`, instruction);
  },
  async update(id: number, instruction: any): Promise<AxiosResponse<boolean>> {
    return await API.put(`/${ROUTE_NAME}/sales/${id}`, instruction);
  },
  async delete(id: number): Promise<AxiosResponse<any>> {
    return await API.put(`/${ROUTE_NAME}/sales/${id}`);
  },
};

export default InstructionService;
